<template>
  <div class="image-preview" @click="handleClose">
    <img :src="imgInfo.url" alt="" @click.stop/>
    <div class="btn" @click.stop="setChatBg">Set as chat background</div>
  </div>
</template>
<script>
export default {
  props: {
    imgInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    setChatBg() {
      this.$emit('setChatBg', this.imgInfo);
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="less" scoped>
.image-preview {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: anchor-center;
  justify-content: center;
  img {
    width: 100%;
    max-height: 100%;
  }
  .btn {
    background: linear-gradient(130.84deg, #3BDC7E 18.93%, #0DCFA9 79.21%);
    height: 54px;
    line-height: 54px;
    border-radius: 33px;
    text-align: center;
    font-size: @fontLarge;
    font-weight: 600;
    position: absolute;
    bottom: 42px;
    width: 328px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }
}
</style>
